// extracted by mini-css-extract-plugin
module.exports = {"WidgetChartMetricsDetails":"_3pfxTIg0","MetricsDetailsHeader":"ukfKuxQt","WidgetSentimentMetricsDetail":"CH8OWVtW"};